import type { ApiClient } from "./client";
import type {
  CatalogProgressMeta,
  CatalogSearchParams,
  CatalogSearchResponse,
  PublicRelease,
} from "./types";

function buildSearchQuery(params: CatalogSearchParams): string {
  const search = new URLSearchParams();
  if (params.q !== undefined && params.q.trim() !== "") {
    search.set("q", params.q.trim());
  }
  if (params.year !== undefined) {
    search.set("year", String(params.year));
  }
  if (params.limit !== undefined) {
    search.set("limit", String(params.limit));
  }
  if (params.cursor !== undefined) {
    search.set("cursor", params.cursor);
  }
  if (params.sort !== undefined) {
    search.set("sort", params.sort);
  }
  if (params.rare === true) {
    search.set("rare", "1");
  }
  return search.toString();
}

export async function searchCatalog(
  client: ApiClient,
  params: CatalogSearchParams,
  options?: { signal?: AbortSignal },
): Promise<CatalogSearchResponse> {
  const query = buildSearchQuery(params);
  return client.request<CatalogSearchResponse>(
    `/api/v1/catalog/search?${query}`,
    { signal: options?.signal },
  );
}

export async function fetchRelease(
  client: ApiClient,
  releaseId: string,
  options?: { signal?: AbortSignal },
): Promise<PublicRelease> {
  return client.request<PublicRelease>(`/api/v1/releases/${releaseId}`, {
    signal: options?.signal,
  });
}

export async function uploadReleaseImage(
  client: ApiClient,
  releaseId: string,
  file: File,
  options?: { signal?: AbortSignal },
): Promise<PublicRelease> {
  const body = new FormData();
  body.append("file", file);
  return client.request<PublicRelease>(
    `/api/v1/catalog/releases/${releaseId}/images`,
    {
      method: "POST",
      body,
      signal: options?.signal,
    },
  );
}

export async function deleteReleaseImage(
  client: ApiClient,
  releaseId: string,
  imageId: string,
  options?: { signal?: AbortSignal },
): Promise<PublicRelease> {
  return client.request<PublicRelease>(`/api/v1/catalog/releases/${releaseId}/images/${imageId}`, {
    method: "DELETE",
    signal: options?.signal,
  });
}

export async function fetchCatalogProgressMeta(
  client: ApiClient,
  options?: { signal?: AbortSignal },
): Promise<CatalogProgressMeta> {
  return client.request<CatalogProgressMeta>("/api/v1/catalog/progress-meta", {
    signal: options?.signal,
  });
}
